import request from '@/assets/js/http/request';

const ENDPOINT = 'https://r-api.ru/api.php';
const CANCEL_REASON_ENDPOINT = 'https://r-api.ru/api_cr.php';
const ID = 'kiwitaxi_lk';
const IS_PROD = process.env.STAGE === 'prod';
const TAG = IS_PROD ? 'prod' : 'test';

function send(msg) {
  /**
   * молча отправить стату
   */
  if (1 || !IS_PROD) {
    return Promise.resolve();
  }
  return request.get(ENDPOINT, { ID, msg, tag: TAG })
    .catch(() => {});
}

function cancelReason(orderId, msg) {
  if (1 || !IS_PROD) {
    console.log(`Отмена заказа. Order id: ${orderId}, причина: ${msg}. note: bp1`);
    return;
  }
  return request.get(CANCEL_REASON_ENDPOINT, { order_url: orderId, ID: 'cancel_reason', text: msg })
    .catch(() => {});
}

export default {
  send,
  cancelReason,
};



// WEBPACK FOOTER //
// ./src/services/EmailGrab.js